/* ---------- steps hover tabs ---------- */
$(".steps_step").on("mouseenter", function () {
  $(".is-active-tab").removeClass("is-active-tab");
  $(this).addClass("is-active-tab");
  let myIndex = $(this).index();
  $(".steps_image").eq(myIndex).addClass("is-active-tab");
});

/* ---------- plyr video ---------- */
$(".plyr_component").each(function (index) {
  let thisComponent = $(this);

  // create plyr settings
  let player = new Plyr(thisComponent.find(".plyr_video")[0], {
    controls: ["play", "progress", "current-time", "mute", "fullscreen"],
    resetOnEnd: true
  });

  // custom video cover
  $(".hero_video-wrap").on("click", function () {
    player.play();
    // Add class and set body overflow to hidden
    thisComponent.addClass("modal-shown");
    $("body").css("overflow", "hidden");
  });

  player.on("ended", (event) => {
    thisComponent.removeClass("hide-cover");
  });

  // pause other playing videos when this one starts playing
  player.on("play", (event) => {
    $(".plyr_component").removeClass("hide-cover");
    thisComponent.addClass("hide-cover");
    let prevPlayingComponent = $(".plyr--playing")
      .closest(".plyr_component")
      .not(thisComponent);
    if (prevPlayingComponent.length > 0) {
      prevPlayingComponent.find(".plyr_pause-trigger")[0].click();
    }
  });

  thisComponent.find(".plyr_close-wrap").on("click", function () {
    player.pause();
    // Remove class and restore body overflow
    thisComponent.removeClass("modal-shown");
    $("body").css("overflow", "auto");
  });

  // exit full screen when video ends
  player.on("ended", (event) => {
    if (player.fullscreen.active) {
      player.fullscreen.exit();
    }
  });
  // set video to contain instead of cover when in full screen mode
  player.on("enterfullscreen", (event) => {
    thisComponent.addClass("contain-video");
  });
  player.on("exitfullscreen", (event) => {
    thisComponent.removeClass("contain-video");
  });
});

/* ---------- looping images ---------- */
document.addEventListener("DOMContentLoaded", function(){

  // Looping Images
  let loopImageDuration = 2000;
  $( ".hero_video-wrap" ).each(function( index ) {
  	let loopParent = $(this);
    setInterval(function () {
      let currentImageLoop = loopParent.find(".hero_video-thumb.is-shown");
      if (currentImageLoop.next().length > 0) {
        currentImageLoop.next().addClass("is-shown");
      } else {
        loopParent.find(".hero_video-thumb").eq(0).addClass("is-shown");
      }
      currentImageLoop.removeClass("is-shown");
    }, loopImageDuration);
	});
  
});
